import { mdiArrowRight } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'

import Copy from '@/components/copy'
import { AccordionItem, AccordionItemContent, AccordionItemIndicator, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { langsAtom } from '@/store/translate'
import { ITextTranslate } from '@/types/gigiChat/Conversation'

import AnswerTextTranslationMarkdown from './AnswerTextTranslationMarkdown'

const Container = ({ data, languagesCodes }: { data: ITextTranslate[]; languagesCodes: string[] }) => {
    const [langs] = useAtom(langsAtom)

    const languageCodeToEnglishNameMap: { [key: string]: string } = {}
    langs.forEach((language) => {
        languageCodeToEnglishNameMap[language.languageCode] = language.languageEnglishName
    })

    const sortedLanguageNames = languagesCodes.map((code) => languageCodeToEnglishNameMap[code])

    const sortedTranslations: ITextTranslate[] = []
    sortedLanguageNames.forEach((languageName) => {
        data.forEach((translation) => {
            if (translation.to.languageEnglishName.includes(languageName) || languageName.includes(translation.to.languageEnglishName)) {
                translation.to.languageEnglishName = languageName
                sortedTranslations.push(translation)
            }
        })
    })

    const textColor = useColorModeValue('rgba(84, 79, 64, 0.7)', 'var(--chakra-colors-white)')

    return (
        <AccordionRoot multiple px="8px" defaultValue={[sortedTranslations[0].to.languageEnglishName]} variant="translations">
            {sortedTranslations.map((item, index) => (
                <AccordionItem key={item.from.languageEnglishName + index} value={item.to.languageEnglishName}>
                    <Flex>
                        <AccordionItemTrigger px="0" _hover={{ backgroundColor: 'transparent' }} indicatorPlacement="none">
                            <Flex>
                                <Flex
                                    textAlign="left"
                                    fontSize="14px"
                                    textTransform="uppercase"
                                    color={textColor}
                                    fontWeight="700"
                                    letterSpacing="0.25px"
                                    marginRight="8px"
                                    alignItems="center"
                                >
                                    <Text>{item.from.languageEnglishName}</Text>
                                    <Icon
                                        path={mdiArrowRight}
                                        size="14px"
                                        style={{ marginTop: '3px', marginLeft: '8px', marginRight: '8px' }}
                                    />
                                    <Text>{item.to.languageEnglishName}</Text>
                                    <AccordionItemIndicator ml="8px" />
                                </Flex>
                            </Flex>
                        </AccordionItemTrigger>
                        <Copy message={item.text} itemId={null} size="20px" iconMarginRight="0" />
                    </Flex>
                    <AccordionItemContent pl="0" pb="16px" pt="0" fontSize="14px" letterSpacing="0.25px">
                        <AnswerTextTranslationMarkdown answer={item.text} />
                    </AccordionItemContent>
                </AccordionItem>
            ))}
        </AccordionRoot>
    )
}

export default Container
